import { render, staticRenderFns } from "./SelecionarBem.vue?vue&type=template&id=64e3df08&scoped=true&"
import script from "./SelecionarBem.vue?vue&type=script&lang=js&"
export * from "./SelecionarBem.vue?vue&type=script&lang=js&"
import style0 from "./SelecionarBem.vue?vue&type=style&index=0&id=64e3df08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e3df08",
  null
  
)

export default component.exports